import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import {
  deleteOperatorProduct,
  getAllOperatorProducts,
} from "store/operatorProducts/actions"
import get from "lodash/get"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllUsers } from "store/users/actions"
import OperatorManagerProductsModal from "./OperatorManagerProductsModal"
import { hasPermission } from "helpers/helpers"
import {sitename} from "../../../constants/constants";

const OperatorProducts = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllOperatorProducts())
  }, [])

  const OperatorProducts = useSelector(
    state => state.operatorProducts.Index ?? []
  )
  const [detailsModal, setDetailsModal] = useState(false)
  const [selectedOperatorManagerId, setSelectedOperatorManagerId] = useState(0)
  const [operatorManagerProducts, setOperatorManagerProducts] = useState({})
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: OperatorProducts.length, // replace later with size(orders),
    custom: true,
  }
  const { SearchBar } = Search

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const handleAddOperatorClick = arg => {
    props.history.push("/operator-products/create")
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeleteOperatorProduct = op => {
    dispatch(deleteOperatorProduct(op.id))
  }

  const handleEditOperatorProductClick = (op, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${op.id}`)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const toggleViewModal = () => setDetailsModal(!detailsModal)

  const operatorProductsColumns = [
    {
      dataField: "id",
      text: "Operator Product#",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.id}</p>
      },
    },
    {
      dataField: "product_channel",
      text: "Channel",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.product_channel.name}</p>
      },
    },
    {
      dataField: "product_category",
      text: "Category",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.product_category.name}</p>
      },
    },
    {
      dataField: "supplier",
      text: "Supplier",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.supplier.name}</p>
      },
    },
    {
      dataField: "product",
      text: "Product",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.product.name}</p>
      },
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, operatorProduct) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-operator_products") && (
              <Link
                to="#"
                className="text-success"
                onClick={e =>
                  handleEditOperatorProductClick(operatorProduct, e)
                }
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}
            {hasPermission("delete-operator_products") && (
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDeleteOperatorProduct(operatorProduct)}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        </>
      ),
    },
  ]

  return (
    <React.Fragment>
      {!isEmpty(operatorManagerProducts) ? (
        <OperatorManagerProductsModal
          isOpen={detailsModal}
          toggle={toggleViewModal}
          selectedOperatorManagerId={selectedOperatorManagerId}
          operatorManagerProducts={operatorManagerProducts}
        />
      ) : null}

      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Operator Products" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={operatorProductsColumns}
                    data={OperatorProducts}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={OperatorProducts}
                        columns={operatorProductsColumns}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              {hasPermission("create-operator_products") && (
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded  mb-2 me-2"
                                      onClick={handleAddOperatorClick}
                                    >
                                      <i className="mdi mdi-plus me-1" />
                                      Add New
                                    </Button>
                                  </div>
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(OperatorProducts)
